module.exports = __webpack_public_path__ + "1791188489487/fonts/summernote.f9b5d83.woff";